module.exports = __webpack_public_path__ + "img/spectrum-css-icons.100dc231.svg";